import api from 'utils/api';

const servicePath = '/news';

export const list = async () => {
  const { data } = await api.get(servicePath);
    
  return data;
}

export const show = async (id) => {
  const { data } = await api.get(`${servicePath}/${id}`);
    
  return data;
}

export const create = async (details) => {
  const { data } = await api.post(servicePath, details);

  return data;
}

export const update = async (id, details) => {
  const { data } = await api.put(`${servicePath}/${id}`, details);

  return data;
}

export const remove = async (id) => {
  return await api.delete(`${servicePath}/${id}`);
}